import { useState } from 'react';
import { isNativeApp } from '../api/axios';
import { publicBaseUrl } from '../utils/urls';

// ملف التطبيق على الخادم باسم يحمل إصداره، وapp.json يشير إلى أحدث إصدار.
// نقرأ app.json عند كل ضغطة (بمعامل يتجاوز الكاش) فيُنزَّل أحدث إصدار دائمًا.
const DOWNLOADS_PATH = '/storage/downloads';

export default function DownloadAppButton() {
  const [loading, setLoading] = useState(false);

  // داخل التطبيق نفسه لا معنى لزر تنزيله.
  if (isNativeApp()) return null;

  const download = async () => {
    setLoading(true);
    try {
      const base = `${publicBaseUrl()}${DOWNLOADS_PATH}`;
      const response = await fetch(`${base}/app.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const { file } = await response.json();
      window.location.href = `${base}/${encodeURIComponent(file)}`;
    } catch {
      window.alert('تعذّر تنزيل التطبيق الآن. حاول مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={download}
      disabled={loading}
      title="تنزيل تطبيق مركز الليزر لأجهزة أندرويد"
      className="inline-flex h-10 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-emerald-300 bg-emerald-50 px-3 text-sm font-semibold text-emerald-700 shadow-sm transition hover:bg-emerald-100 disabled:opacity-60"
    >
      <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 4v11" />
        <path d="M7 10l5 5 5-5" />
        <path d="M5 20h14" />
      </svg>
      {loading ? 'جاري التحضير...' : 'تنزيل التطبيق'}
    </button>
  );
}
